
import MultiplePhonePicker from "../../../components/form-components/MultiplePhonePicker.vue";
import DatePicker from "../../../components/form-components/DatePicker.vue";
import Vue from "vue";
import FileUploader from "@/components/form-components/FileUploader.vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";
import API from "@/api/API";
import { APPLICATION_STATUSES } from "@/static/constants";

export default Vue.extend({
  name: "General",

  components: {
    FileUploader,
    DatePicker,
    MultiplePhonePicker,
    PhonePicker,
  },

  data: () => ({
    APPLICATION_STATUSES,
    model: {
      application: {} as any,
      application_study_types: [] as Array<any>,
      need_hostel: false as boolean,
      abiturient: {
        has_driving_license: false as boolean,
        is_married: false as boolean,
      } as any,
      abiturient_contacts: [] as Array<any>,
      graduated_university: {} as any,
      scientific_publications: [{} as any] as Array<any>,
      documents: [{} as any] as Array<any>,
      abiturient_documents: [{ type: "diplom_copy" } as any] as Array<any>,
      family_members: {
        mother: { role: "mother" } as any,
        father: { role: "father" } as any,
        husband: { role: "husband", home_phone: null } as any,
        wife: { role: "wife", home_phone: null } as any,
        children: [{ role: "child" } as any] as Array<any>,
      } as any,
      foreign_languages: [{} as any] as Array<any>,
      sex: [{} as any] as Array<any>,
      rh: [{} as any] as Array<any>,
      residence_medium: [{} as any] as Array<any>,
      blood_type: [{} as any] as Array<any>,
      obtained_title: [{} as any] as Array<any>,
      required_documents: {} as any,
    } as any,
    requiredDocuments: {} as any,
  }),

  computed: {
    isMale(): boolean {
      return this.model.abiturient.sex === "m";
    },
    abiturientFullName() {
      return `${this.model.abiturient.first_name} ${this.model.abiturient.last_name}`;
    },
    optionalDocuments() {
      return (
        this.model.abiturient_documents?.filter((item: any) =>
          item.type.startsWith("optional_copy_")
        ) || []
      );
    },
    badgeColor() {
      return this.model.application?.status?.color;
    },
    language() {
      return this.$store.getters["localization/getCurrent"];
    },
    isAwaiting() {
      return (
        this.model.application?.status?.alias === APPLICATION_STATUSES.awaiting
      );
    },
    isVerified() {
      return (
        this.model.application?.status?.alias === APPLICATION_STATUSES.verified
      );
    },
    isCanceled() {
      return (
        this.model.application?.status?.alias === APPLICATION_STATUSES.canceled
      );
    },
    isPrintable() {
      return (
        this.model.application?.status?.alias !==
          APPLICATION_STATUSES.canceled &&
        this.model.application?.status?.alias !== APPLICATION_STATUSES.draft
      );
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.applicationRequests().previewById(
        Number(to.params.id)
      );

      next((vm) => {
        let familyMembers = {
          children: [] as Array<any>,
        } as any;

        for (const member of item.family_members) {
          if (member.role === "child") {
            familyMembers.children.push(member);
          } else {
            familyMembers[member.role] = member;
          }
        }

        familyMembers.children = familyMembers.children.filter(
          (item: any) => item.birthday && item.full_name
        );

        item.family_members = { ...vm.model.family_members, ...familyMembers };

        item.application_study_types = item.application_study_types
          .map((item: string) =>
            vm.$t(`applications.form.application.finance_type.${item}`)
          )
          .join(",");

        for (const document of item.abiturient_documents) {
          if (!document.type.startsWith("optional_copy_")) {
            vm.requiredDocuments[document.type] = document;
          }
        }

        vm.model = item;

        vm.$nextTick(() => {
          vm.fullLoaded = true;
          vm.$forceUpdate();
        });
      });
    } catch (e) {
      await this.$store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    edit(): void {
      this.$router.push(`/application/edit/${this.model.application.id}`);
    },
    async cancelApplication() {
      try {
        await this.$API.applicationRequests().cancel(this.model.application.id);
        //@ts-ignore
        this.$router.go(this.$router.currentRoute);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async downloadFile(file: any) {
      if (file) {
        const element = document.createElement("a");
        element.setAttribute("href", file.url);
        element.setAttribute("download", file.name);
        element.setAttribute("target", "_blank");
        element.click();
      }
    },
    async printResults() {
      try {
        const file = await this.$API
          .applications()
          .printApplication(Number(this.$route.params.id));

        await this.downloadFile(file);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async setStatusVerified(id: number): Promise<void> {
      try {
        await this.$API.applicationRequests().setStatusVerify(id);
        await this.$store.dispatch(
          "alert/showSuccess",
          this.$t("applicationRequests.form.message.verified")
        );
        location.reload();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
